import React from "react";
import Ornament from "@/components/Ornament";
import Reveal from "@/components/Reveal";

const Gifts = () => (
  <section id="gifts" className="section gifts" data-testid="section-gifts">
    <Ornament />
    <Reveal as="h2" className="script-h2">
      Gifts
    </Reveal>
    <Reveal as="p" className="lead center">
      Your presence at our wedding is the greatest gift of all.
    </Reveal>
  </section>
);

export default Gifts;
